import Vue from 'vue'
import Vuex from 'vuex'
import { PaasTenant } from '@/models/paas-tenant.js'
import { Theme } from '@/lib/theme'
import { PaasDefaultJson } from '@/models/paas-default-json.js'
import { merge } from 'lodash'

Vue.use(Vuex)

const state = {
    mHeaderOn: false,
    logo: '',
    meta: {},
    baseInfo: {},
    baseInfoM:{},
    loginInfo:{}
}

const getters = {
    themeColor: (state) => {
        return state.baseInfo.themeColor
    },
    themeColorM: (state) => {
        return state.baseInfoM.themeColor
    },
    isShowLoginBtn: (state) => {
        return state.loginInfo.isShowLoginBtn === undefined 
        ? true : state.loginInfo.isShowLoginBtn
    },
}

const mutations = {
    switchMHeader(state){
        state.mHeaderOn = !state.mHeaderOn
    },
    SET_LOGO(state, url){
        state.logo = url
    },
    SET_META(state, meta){
        state.meta = meta
    },
    SET_BASE_INFO(state, data){
        state.baseInfo = data
    },
    SET_BASE_INFO_M(state, data){
        state.baseInfoM = data
    },
    SET_LOGIN_INFO(state,data){
        state.loginInfo = data
    }
}

const actions = {
    GET_BASE_INFO({ commit }){
        commit('SET_LOGO', PaasTenant.getLogo())
        return PaasTenant.getBaseInfo().then(async res => {
            const data = merge({}, PaasDefaultJson.baseInfo, res)
            commit('SET_BASE_INFO', data)
            await Theme.changeElementUI(data.themeColor)
        })
    },
    GET_BASE_INFO_M({commit}){
        commit('SET_LOGO',PaasTenant.getLogo())
        return PaasTenant.getBaseInfoM().then(async res =>{
            commit('SET_BASE_INFO_M',res)
            await Theme.changeElementUI(res.themeColor)
        })
    },
    GET_LOGIN_INFO({commit}){
        PaasTenant.getLoginInfo().then(res =>{
            commit('SET_LOGIN_INFO',res)
        })
    }
}

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions
})


// WEBPACK FOOTER //
// ./src/store/index.js